<section class="request" *ngIf="projectData">
  <h5 class="request--title">
    {{ 'projectData' | i18next }}
  </h5>
  <div *ngIf="!isModify && projectData">
    <div class="projectData">
      <div class="rowInfo" *ngIf="showAreaAndDepartament">
        <p class="label">
          {{ 'area' | i18next }}
        </p>
        <p class="text">
          {{
            projectData.department.area ? projectData.department.area.name : '-'
          }}
        </p>
      </div>
      <div class="rowInfo" *ngIf="showAreaAndDepartament">
        <p class="label">
          {{ 'requestPetitionerDependency' | i18next }}
        </p>
        <p class="text">
          {{ projectData.department ? projectData.department.name : '-' }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'orderReference' | i18next }}</p>
        <p class="text">
          {{ projectData.orderReference ? projectData.orderReference : '-' }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'launchCosts' | i18next }}</p>
        <p class="text">
          {{ projectData.launch ? 'Si' : 'No' }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'dealerCode' | i18next }}</p>
        <p class="text">
          {{ projectData.dealer ? projectData.dealer.code : '-' }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'ceco' | i18next }}</p>
        <p class="text">
          {{ projectData.ceco ? projectData.ceco : '-' }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'projectNeedDate' | i18next }}</p>
        <p class="text">
          {{ projectData.requiredDate ? projectData.requiredDate : '-' }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'projectAppraisalExpectedDate' | i18next }}</p>
        <p class="text">
          {{ projectData.returnDate ? projectData.returnDate : '-' }}
        </p>
      </div>
      <div class="rowInfo" *ngIf="showAreaAndDepartament">
        <p class="label">{{ 'sop' | i18next }}</p>
        <p class="text">
          {{ projectData.sop ? projectData.sop : '-' }}
        </p>
      </div>
      <div class="rowInfo" *ngIf="showAreaAndDepartament">
        <p class="label">{{ 'EA' | i18next }}</p>
        <p class="text">
          {{ projectData.ea ? projectData.ea : '-' }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'cops' | i18next }}</p>
        <p class="text">
          {{ projectData.daisy ? projectData.daisy : '-' }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'vds' | i18next }}</p>
        <p class="text">
          {{ projectData.vds ? projectData.vds : '-' }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'appraisalExpectedKm' | i18next }}</p>
        <p class="text">
          {{ projectData.estimatedKms ? projectData.estimatedKms : '-' }}
        </p>
      </div>
      <div class="rowInfo" *ngIf="showAreaAndDepartament">
        <p class="label">{{ 'bnr' | i18next }}</p>
        <p class="text">
          {{ projectData.bnr ? projectData.bnr : '-' }}
        </p>
      </div>
    </div>
    <!-- New Vehicle -->
    <div *ngIf="projectData.projectNewVehicle" class="projectData">
      <div class="projectData--title">
        <h5>{{ 'bookVehicleDataTitle' | i18next }}</h5>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'finishes' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectNewVehicle.finishes
              ? projectData.projectNewVehicle.finishes
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'requestPccCountry' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectNewVehicle.nationalSalesPlan
              ? projectData.projectNewVehicle.nationalSalesPlan
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'requestPccMY' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectNewVehicle.modelYear
              ? projectData.projectNewVehicle.modelYear
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'model' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectNewVehicle.model
              ? projectData.projectNewVehicle.model
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'requestPccTMAIMG' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectNewVehicle.tmaimg
              ? projectData.projectNewVehicle.tmaimg
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'usePreview' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectNewVehicle.usePreview
              ? projectData.projectNewVehicle.usePreview
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'optionals' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectNewVehicle.optionals
              ? projectData.projectNewVehicle.optionals
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'prNumbers' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectNewVehicle.prNumbers
              ? projectData.projectNewVehicle.prNumbers
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'projectDestination' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectNewVehicle.destinationCode
              ? projectData.projectNewVehicle.destinationCode
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'prEngine' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectNewVehicle.prEngine
              ? projectData.projectNewVehicle.prEngine
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'engineDescription' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectNewVehicle.engineDescription
              ? projectData.projectNewVehicle.engineDescription
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'exteriorColor' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectNewVehicle.exteriorColor
              ? projectData.projectNewVehicle.exteriorColor
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'interiorColor' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectNewVehicle.interiorColor
              ? projectData.projectNewVehicle.interiorColor
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'orderNumber' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectNewVehicle.orderNumber
              ? projectData.projectNewVehicle.orderNumber
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'transferToThird' | i18next }}</p>
        <p class="text">
          {{ projectData.projectNewVehicle.thirdPartyTransfer ? 'Si' : 'No' }}
        </p>
      </div>
    </div>
    <!-- Stock Vehicle -->
    <div *ngIf="projectData.projectStockVehicle" class="projectData">
      <div class="projectData--title">
        <h5>{{ 'bookVehicleDataTitle' | i18next }}</h5>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'vin' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectStockVehicle.VIN
              ? projectData.projectStockVehicle.VIN
              : '-'
          }}
        </p>
      </div>
    </div>
    <!-- Regularization Vehicle -->
    <div *ngIf="projectData.projectRegularitationVehicle" class="projectData">
      <div class="projectData--title">
        <h5>{{ 'bookVehicleDataTitle' | i18next }}</h5>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'finishes' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectRegularitationVehicle.finishes
              ? projectData.projectRegularitationVehicle.finishes
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'requestPccCountry' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectRegularitationVehicle.nationalSalesPlan
              ? projectData.projectRegularitationVehicle.nationalSalesPlan
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'requestPccMY' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectRegularitationVehicle.modelYear
              ? projectData.projectRegularitationVehicle.modelYear
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'model' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectRegularitationVehicle.model
              ? projectData.projectRegularitationVehicle.model
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'requestPccTMAIMG' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectRegularitationVehicle.tmaimg
              ? projectData.projectRegularitationVehicle.tmaimg
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'usePreview' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectRegularitationVehicle.usePreview
              ? projectData.projectRegularitationVehicle.usePreview
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'optionals' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectRegularitationVehicle.optionals
              ? projectData.projectRegularitationVehicle.optionals
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'prNumbers' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectRegularitationVehicle.prNumbers
              ? projectData.projectRegularitationVehicle.prNumbers
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'projectDestination' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectRegularitationVehicle.destinationCode
              ? projectData.projectRegularitationVehicle.destinationCode
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'prEngine' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectRegularitationVehicle.prEngine
              ? projectData.projectRegularitationVehicle.prEngine
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'engineDescription' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectRegularitationVehicle.engineDescription
              ? projectData.projectRegularitationVehicle.engineDescription
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'color' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectRegularitationVehicle.exteriorColorDescription
              ? projectData.projectRegularitationVehicle
                  .exteriorColorDescription
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'orderNumber' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectRegularitationVehicle.orderNumber
              ? projectData.projectRegularitationVehicle.orderNumber
              : '-'
          }}
        </p>
      </div>
    </div>
    <!-- Other Vehicle -->
    <div *ngIf="projectData.projectOtherVehicle" class="projectData">
      <div class="projectData--title">
        <h5>{{ 'bookVehicleDataTitle' | i18next }}</h5>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'brand' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectOtherVehicle.brand
              ? projectData.projectOtherVehicle.brand
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'model' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectOtherVehicle.model
              ? projectData.projectOtherVehicle.model
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'finishes' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectOtherVehicle.finishes
              ? projectData.projectOtherVehicle.finishes
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'engine' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectOtherVehicle.engine
              ? projectData.projectOtherVehicle.engine
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'usePreview' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectOtherVehicle.usePreview
              ? projectData.projectOtherVehicle.usePreview
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'requestPccEmissions' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectOtherVehicle.estimatedCO2
              ? projectData.projectOtherVehicle.estimatedCO2
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'projectDestination' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectOtherVehicle.destination
              ? projectData.projectOtherVehicle.destination
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'color' | i18next }}</p>
        <p class="text">
          {{
            projectData.projectOtherVehicle.exteriorColorDescription
              ? projectData.projectOtherVehicle.exteriorColorDescription
              : '-'
          }}
        </p>
      </div>
    </div>
    <!-- Plate management -->
    <div class="projectData">
      <div class="projectData--title">
        <h5>{{ 'enrollmentManagement' | i18next }}</h5>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'registered' | i18next }}</p>
        <p class="text">
          {{ projectData.licensePlateManagement.management ? 'Si' : 'No' }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'plateNumber' | i18next }}</p>
        <p class="text">
          {{
            projectData.licensePlateManagement.plateNumber
              ? projectData.licensePlateManagement.plateNumber
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'summaryVinNumberDate' | i18next }}</p>
        <p class="text">
          {{
            projectData.licensePlateManagement.registrationDate
              ? projectData.licensePlateManagement.registrationDate
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'townHallCode' | i18next }}</p>
        <p class="text">
          {{
            projectData.licensePlateManagement.townHallCode
              ? projectData.licensePlateManagement.townHallCode
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'summaryInsuranceType' | i18next }}</p>
        <p class="text">
          {{
            projectData.licensePlateManagement.insuranceType
              ? projectData.licensePlateManagement.insuranceType
              : '-'
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'deliveryDate' | i18next }}</p>
        <p class="text">
          {{
            projectData.licensePlateManagement.deliveryDate
              ? projectData.licensePlateManagement.deliveryDate
              : '-'
          }}
        </p>
      </div>
    </div>
    <!-- Costs -->
    <div *ngIf="projectData.costs" class="projectData">
      <div class="projectData--title">
        <h5>{{ 'preserieData' | i18next }}</h5>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'specialType' | i18next }}</p>
        <p class="text">
          {{
            projectData.costs.especialType && showOtherForm
              ? projectData.costs.especialType
              : translate.translateProjects(projectData.costs.especialType)
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'pressSubtype' | i18next }}</p>
        <p class="text">
          {{ translate.translateProjects(projectData.costs.pressSubType) }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'materialType' | i18next }}</p>
        <p class="text">
          {{
            projectData.costs.materialType && showOtherForm
              ? projectData.costs.materialType
              : translate.translateProjects(projectData.costs.materialType)
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'preseriesType' | i18next }}</p>
        <p class="text">
          {{ translate.translateProjects(projectData.costs.preserieType) }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'subtypeSeries' | i18next }}</p>
        <p class="text">
          {{
            projectData.costs.serieSubType && showOtherForm
              ? projectData.costs.serieSubType
              : translate.translateProjects(projectData.costs.serieSubType)
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'projectType' | i18next }}</p>
        <p class="text">
          {{ translate.translateProjects(projectData.costs.projectType) }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'projectML' | i18next }}</p>
        <p class="text">
          {{
            projectData.costs.mlProject
              ? projectData.costs.mlProject
              : ('noData' | i18next)
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'preseriesCost' | i18next }}</p>
        <p class="text">
          {{
            projectData.costs.preserieCost ||
            projectData.costs.preserieCost === 0
              ? projectData.costs.preserieCost
              : ('noData' | i18next)
          }}
        </p>
      </div>
      <div class="rowInfo">
        <p class="label">{{ 'seriesCost' | i18next }}</p>
        <p class="text">
          {{
            projectData.costs.serieCost || projectData.costs.serieCost === 0
              ? projectData.costs.serieCost
              : ('noData' | i18next)
          }}
        </p>
      </div>
    </div>
  </div>
  <form class="content" [formGroup]="form" *ngIf="isModify">
    <section class="content--item" *ngIf="!spinner">
      <div class="form-two-columns" *ngIf="showAreaAndDepartament">
        <mat-form-field>
          <mat-label>{{ 'area' | i18next }}</mat-label>
          <mat-select formControlName="area" (selectionChange)="areaChange()">
            <mat-option *ngFor="let area of areas" [value]="area.id">
              {{ area.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'requestPetitionerDependency' | i18next }}</mat-label>
          <mat-select formControlName="departament" [disabled]="true">
            <mat-option
              *ngFor="let departament of departaments"
              [value]="departament.id"
            >
              {{ departament.id + ' - ' + departament.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form-two-columns" *ngIf="showAreaAndDepartament">
        <div class="form-title">
          <h6 class="content--title">{{ 'enterVehicleData' | i18next }}</h6>
        </div>
        <mat-form-field>
          <mat-label>{{ 'projectNeedDate' | i18next }}</mat-label>
          <input
            matInput
            [matDatepicker]="datePicker"
            formControlName="date"
            placeholder="MM/DD/YYYY"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="datePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #datePicker (closed)="close()"></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'projectAppraisalExpectedDate' | i18next }}</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            formControlName="returnDate"
            [min]="form.get('date')!.value"
            placeholder="MM/DD/YYYY"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker (closed)="close()"></mat-datepicker>
        </mat-form-field>
      </div>
      <div
        class="form-two-columns"
        *ngIf="vehicles.length === 0 && showAreaAndDepartament && !stockVehicle"
      >
        <mat-form-field>
          <mat-label>{{ 'model' | i18next }}</mat-label>
          <input type="text" matInput formControlName="model" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'requestPccTMAIMG' | i18next }}</mat-label>
          <input type="text" matInput formControlName="tmaimg" maxlength="6" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'finishes' | i18next }}</mat-label>
          <input type="text" matInput formControlName="finish" />
        </mat-form-field>
        <mat-form-field *ngIf="showReguForm">
          <mat-label>{{ 'color' | i18next }}</mat-label>
          <input type="text" matInput formControlName="color" />
        </mat-form-field>
      </div>
      <div class="form-two-columns" *ngIf="showAreaAndDepartament">
        <div class="form-checkbox-launch">
          <mat-label class="content--checkbox">
            {{ 'launchCosts' | i18next }}
          </mat-label>
          <mat-checkbox
            formControlName="launch"
            class="mat-checkbox-force-color"
          >
          </mat-checkbox>
        </div>
        <mat-form-field>
          <mat-label>{{ 'dealerCode' | i18next }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="dealerCode"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="updateDealerCodeAC($event)"
            [displayWith]="displayDealerFn"
          >
            <mat-option *ngFor="let dealer of filteredDealers" [value]="dealer">
              {{ dealer.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'ceco' | i18next }}</mat-label>
          <mat-select formControlName="ceco">
            <mat-option *ngFor="let ceco of cecos" [value]="ceco">
              {{ ceco }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="showNewForm">
          <mat-label>{{ 'exteriorColor' | i18next }}</mat-label>
          <input
            type="text"
            matInput
            formControlName="exteriorColor"
            maxlength="4"
          />
        </mat-form-field>
        <mat-form-field *ngIf="showNewForm">
          <mat-label>{{ 'interiorColor' | i18next }}</mat-label>
          <input
            type="text"
            matInput
            formControlName="interiorColor"
            maxlength="2"
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'EA' | i18next }}</mat-label>
          <input type="text" matInput formControlName="ea" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'orderReference' | i18next }}</mat-label>
          <input type="text" matInput formControlName="reference" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'sop' | i18next }}</mat-label>
          <input
            matInput
            [matDatepicker]="sopPicker"
            formControlName="sop"
            placeholder="MM/DD/YYYY"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="sopPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #sopPicker (closed)="closeSop()"></mat-datepicker>
        </mat-form-field>
        <mat-form-field id="cops-anchor">
          <mat-label>{{ 'cops' | i18next }}</mat-label>
          <input type="text" matInput formControlName="cops" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'vds' | i18next }}</mat-label>
          <input type="text" matInput formControlName="vds" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'appraisalExpectedKm' | i18next }}</mat-label>
          <input type="number" matInput formControlName="kms" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'bnr' | i18next }}</mat-label>
          <input type="text" matInput formControlName="bnr" />
        </mat-form-field>
      </div>
      <div
        class="form-two-columns"
        *ngIf="vehicles.length === 0 && showAreaAndDepartament && !stockVehicle"
      >
        <mat-form-field>
          <mat-label>{{ 'requestPccCountry' | i18next }}</mat-label>
          <input type="text" matInput formControlName="country" maxlength="3" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'requestPccMY' | i18next }}</mat-label>
          <input type="text" matInput formControlName="my" maxlength="4" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'usePreview' | i18next }}</mat-label>
          <input type="text" matInput formControlName="use" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'destination' | i18next }}</mat-label>
          <input type="text" matInput formControlName="destination" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'optionals' | i18next }}</mat-label>
          <input type="text" matInput formControlName="optionals" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'prNumbers' | i18next }}</mat-label>
          <input type="text" matInput formControlName="prNumbers" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'prEngine' | i18next }}</mat-label>
          <input type="text" matInput formControlName="prMotor" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'engineDescription' | i18next }}</mat-label>
          <input type="text" matInput formControlName="descriptionEngine" />
        </mat-form-field>
      </div>
      <div class="form-two-columns" *ngIf="showAreaAndDepartament">
        <mat-form-field
          *ngIf="showReguForm && vehicles.length === 0 && !stockVehicle"
        >
          <mat-label>{{ 'orderNumber' | i18next }}</mat-label>
          <input type="number" matInput formControlName="orderNumber" />
        </mat-form-field>
        <mat-form-field
          *ngIf="showReguForm && vehicles.length === 0 && !stockVehicle"
        >
          <mat-label>{{ 'vinNumber' | i18next }}</mat-label>
          <input type="text" matInput formControlName="vin" maxlength="17" />
        </mat-form-field>
        <div class="checkbox">
          <mat-label class="content--checkbox">
            {{ 'registeredSN' | i18next }}
          </mat-label>
          <mat-checkbox formControlName="registered"> </mat-checkbox>
        </div>
      </div>
      <div class="form-two-columns" *ngIf="showNewForm">
        <div class="form-title">
          <h6 class="content--title">{{ 'preseriesData' | i18next }}</h6>
        </div>
        <mat-form-field>
          <mat-label>{{ 'specialType' | i18next }}</mat-label>
          <mat-select
            formControlName="specialType"
            (selectionChange)="onSpecialTypeChange()"
          >
            <mat-option value="PROTOTYPE">{{
              'prototype' | i18next
            }}</mat-option>
            <mat-option value="PRESERIE">{{
              'preseries' | i18next
            }}</mat-option>
            <mat-option value="PRE_PRESERIE">{{
              'prePreseries' | i18next
            }}</mat-option>
            <mat-option value="SERIE">{{ 'series' | i18next }}</mat-option>
            <mat-option value="ZEROSERIE">{{ 'series0' | i18next }}</mat-option>
            <mat-option value="PRESS">{{
              'pressAndSalons' | i18next
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="form.value.specialType === 'PRESS'">
          <mat-label>{{ 'pressSubtype' | i18next }}</mat-label>
          <mat-select formControlName="pressSubtype">
            <mat-option> </mat-option>
            <mat-option value="SUBSTITUTION">{{
              'substitution' | i18next
            }}</mat-option>
            <mat-option value="ADDITIONAL">{{
              'additional' | i18next
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'materialType' | i18next }}</mat-label>
          <mat-select formControlName="materialType">
            <mat-option value="CARRIAGE">{{ 'bodywork' | i18next }}</mat-option>
            <mat-option value="VEHICLE">{{ 'vehicle' | i18next }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'preseriesType' | i18next }}</mat-label>
          <mat-select
            formControlName="preseriesType"
            (selectionChange)="onPreseriesTypeChange()"
          >
            <mat-option value="VFF">{{ 'VFF' | i18next }}</mat-option>
            <mat-option value="PVS">{{ 'PVS' | i18next }}</mat-option>
            <mat-option value="ZEROSERIE">{{ 'series0' | i18next }}</mat-option>
            <mat-option value="EMPTY">{{ 'NA' | i18next }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'subtypeSeries' | i18next }}</mat-label>
          <mat-select formControlName="subtypeSeries">
            <mat-option> </mat-option>
            <mat-option value="DEVELOPMENT">{{
              'developmentSeries' | i18next
            }}</mat-option>
            <mat-option value="MISCELLANEOUS">{{
              'variousSeries' | i18next
            }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'projectType' | i18next }}</mat-label>
          <mat-select
            formControlName="projectType"
            (selectionChange)="onProjectTypeChange()"
          >
            <mat-option> </mat-option>
            <mat-option value="BASE_PROJECT">{{
              'baseProject' | i18next
            }}</mat-option>
            <mat-option value="PA">{{ 'PA' | i18next }}</mat-option>
            <mat-option value="MY_MP">{{ 'modelpflege' | i18next }}</mat-option>
            <mat-option value="EMPTY">{{ 'NA' | i18next }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'projectML' | i18next }}</mat-label>
          <input type="text" matInput formControlName="projectML" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'preseriesCost' | i18next }}</mat-label>
          <input
            type="number"
            matInput
            formControlName="preseriesCost"
            readonly
          />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'seriesCost' | i18next }}</mat-label>
          <input type="number" matInput formControlName="seriesCost" readonly />
        </mat-form-field>
        <div class="checkbox">
          <mat-label class="content--checkbox">
            {{ 'transferToThird' | i18next }}
          </mat-label>
          <mat-checkbox formControlName="transferToThird"> </mat-checkbox>
        </div>
        <div>
          <button
            class="form-two-columns--btn"
            mat-button
            [disabled]="
              form.value.specialType === 'PROTOTYPE' ||
              form.value.specialType === 'SERIE' ||
              (form.value.specialType === 'PRESERIE' &&
                form.value.projectType === 'EMPTY')
            "
            (click)="calculateCosts()"
          >
            {{ 'calculateCost' | i18next | uppercase }}
          </button>
          <p
            class="text-button"
            *ngIf="
              form.value.specialType === 'PROTOTYPE' ||
              form.value.specialType === 'SERIE' ||
              (form.value.specialType === 'PRESERIE' &&
                form.value.projectType === 'EMPTY')
            "
          >
            {{ 'textDisabledCalculateCost' | i18next }}
          </p>
        </div>
        <div>
          <button
            class="form-two-columns--btn"
            mat-button
            (click)="seeCostsDetail()"
          >
            {{ 'seeCostDetail' | i18next | uppercase }}
          </button>
        </div>
      </div>
      <div class="form-two-columns" *ngIf="showOtherForm">
        <div class="form-title">
          <h6 class="content--title">{{ 'enrollmentManagement' | i18next }}</h6>
        </div>
        <div class="form-checkbox">
          <mat-label class="content--checkbox">
            {{ 'checkedManagement' | i18next }}
          </mat-label>
          <mat-checkbox formControlName="checkedManagement"> </mat-checkbox>
        </div>
        <mat-form-field>
          <mat-label>{{ 'plateNumber' | i18next }}</mat-label>
          <input type="text" matInput formControlName="plateNumber" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'summaryVinNumberDate' | i18next }}</mat-label>
          <input
            matInput
            [matDatepicker]="plateNumberPicker"
            formControlName="plateNumberDate"
            placeholder="MM/DD/YYYY"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="plateNumberPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker
            #plateNumberPicker
            (closed)="close()"
          ></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'townHallCode' | i18next }}</mat-label>
          <input type="text" matInput formControlName="townHallCode" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'summaryInsuranceType' | i18next }}</mat-label>
          <input type="text" matInput formControlName="insuranceType" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'deliveryDate' | i18next }}</mat-label>
          <input
            matInput
            [matDatepicker]="deliveryPicker"
            formControlName="deliveryDate"
            placeholder="MM/DD/YYYY"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="deliveryPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #deliveryPicker (closed)="close()"></mat-datepicker>
        </mat-form-field>
        <div class="form-title">
          <h6 class="content--title">{{ 'requestedVehicle' | i18next }}</h6>
        </div>
        <mat-form-field>
          <mat-label>{{ 'brand' | i18next }}</mat-label>
          <input type="text" matInput formControlName="brand" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'model' | i18next }}</mat-label>
          <input type="text" matInput formControlName="model" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'projectNeedDate' | i18next }}</mat-label>
          <input
            matInput
            [matDatepicker]="datePicker"
            formControlName="date"
            placeholder="MM/DD/YYYY"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="datePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #datePicker (closed)="close()"></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'projectAppraisalExpectedDate' | i18next }}</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            formControlName="returnDate"
            [min]="form.get('date')!.value"
            placeholder="MM/DD/YYYY"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker (closed)="close()"></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'specialType' | i18next }}</mat-label>
          <input type="text" matInput formControlName="specialType" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'materialType' | i18next }}</mat-label>
          <input type="text" matInput formControlName="materialType" />
        </mat-form-field>
        <div class="form-checkbox-launch">
          <mat-label class="content--checkbox">
            {{ 'launchCosts' | i18next }}
          </mat-label>
          <mat-checkbox
            formControlName="launch"
            class="mat-checkbox-force-color"
          >
          </mat-checkbox>
        </div>
        <mat-form-field>
          <mat-label>{{ 'dealerCode' | i18next }}</mat-label>
          <input
            matInput
            type="text"
            formControlName="dealerCode"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="updateDealerCodeAC($event)"
            [displayWith]="displayDealerFn"
          >
            <mat-option *ngFor="let dealer of filteredDealers" [value]="dealer">
              {{ dealer.name }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'ceco' | i18next }}</mat-label>
          <mat-select formControlName="ceco">
            <mat-option *ngFor="let ceco of cecos" [value]="ceco">
              {{ ceco }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'color' | i18next }}</mat-label>
          <input type="text" matInput formControlName="color" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'orderReference' | i18next }}</mat-label>
          <input type="text" matInput formControlName="reference" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'appraisalExpectedKm' | i18next }}</mat-label>
          <input type="number" matInput formControlName="kms" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'finishes' | i18next }}</mat-label>
          <input type="text" matInput formControlName="finishes" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'engine' | i18next }}</mat-label>
          <input type="text" matInput formControlName="engine" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'usePreview' | i18next }}</mat-label>
          <input type="text" matInput formControlName="use" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'cops' | i18next }}</mat-label>
          <input type="text" matInput formControlName="cops" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'vds' | i18next }}</mat-label>
          <input type="text" matInput formControlName="vds" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'projectDestination' | i18next }}</mat-label>
          <input type="text" matInput formControlName="destination" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'seriesSubtype' | i18next }}</mat-label>
          <input type="text" matInput formControlName="subtypeSeries" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'seriesCost' | i18next }}</mat-label>
          <input type="number" matInput formControlName="seriesCost" />
        </mat-form-field>
        <div class="form-title">
          <h6 class="content--title">{{ 'manufacturedVehicle' | i18next }}</h6>
        </div>
        <mat-form-field>
          <mat-label>{{ 'requestPccEmissions' | i18next }}</mat-label>
          <input type="number" matInput formControlName="emission" />
        </mat-form-field>
      </div>
      <button
        *ngIf="isModify"
        class="modifyBtn"
        (click)="modifyProject()"
        [disabled]="form.invalid"
        [ngStyle]="
          form.invalid
            ? { 'background-color': '#efffc1', 'font-weight': 'normal' }
            : { 'background-color': '#c8f546' }
        "
      >
        {{ 'btnSave' | i18next | uppercase }}
      </button>
    </section>
    <div class="text-center spinner-container" *ngIf="spinner">
      <div class="spinner-border spinner" role="status"></div>
    </div>
  </form>
</section>
